import { LoanProfitAndLossChangeOwner } from 'constants/loanChanges';

export const PERCENTAGE = 100;

export const ProfitAndLossFieldName = {
  NET_BUY_PRICE: 'netBuyPrice',
  SRP_PAID_OUT: 'srpPaidOut',
  HEDGE_COST: 'hedgeCost',
  TOTAL_BUY_PRICE: 'totalBuyPrice',
  NET_SELL_PRICE: 'netSellPrice',
  SRP_FROM_INVESTOR: 'srpFromInvestor',
  TOTAL_SELL_PRICE: 'totalSellPrice',
  PROFIT_LOSS_PERCENT: 'profitLossPercent',
  PROFIT_LOSS_DOLLAR: 'profitLossDollar',
};

export const PROFIT_AND_LOSS_CHANGE_SOURCES = {
  [LoanProfitAndLossChangeOwner.PROFIT_AND_LOSS]: {
    [ProfitAndLossFieldName.NET_BUY_PRICE]: 'NetBuyPrice',
    [ProfitAndLossFieldName.SRP_PAID_OUT]: 'SrpPaidOut',
    [ProfitAndLossFieldName.HEDGE_COST]: 'HedgeCost',
    [ProfitAndLossFieldName.TOTAL_BUY_PRICE]: 'TotalBuyPrice',
    [ProfitAndLossFieldName.NET_SELL_PRICE]: 'NetSellPrice',
    [ProfitAndLossFieldName.SRP_FROM_INVESTOR]: 'SrpFromInvestor',
    [ProfitAndLossFieldName.TOTAL_SELL_PRICE]: 'TotalSellPrice',
    [ProfitAndLossFieldName.PROFIT_LOSS_PERCENT]: 'ProfitLossPercent',
    [ProfitAndLossFieldName.PROFIT_LOSS_DOLLAR]: 'ProfitLossDollar',
  },
};

export const MANUAL_BUY_SIDE_FIELD_NAMES = [
  ProfitAndLossFieldName.SRP_PAID_OUT,
  ProfitAndLossFieldName.HEDGE_COST,
];

export const MANUAL_SELL_SIDE_FIELD_NAMES = [
  ProfitAndLossFieldName.NET_SELL_PRICE,
  ProfitAndLossFieldName.SRP_FROM_INVESTOR,
];

export const PROFIT_LOSS_RESULT_FIELD_NAMES = [
  ProfitAndLossFieldName.PROFIT_LOSS_PERCENT,
  ProfitAndLossFieldName.PROFIT_LOSS_DOLLAR,
];
